var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "old-conversations" } }, [
    _c("div", { staticClass: "custom-content" }, [
      _c("div", { staticClass: "header" }, [
        _c("div", {
          staticClass: "closeBtn",
          on: {
            click: function ($event) {
              return _vm.toggleChatHistory(false)
            },
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [
          _vm.oldConversations.length
            ? _c(
                "div",
                { staticClass: "d-flex align-items-center" },
                [
                  _c(
                    "md-button",
                    {
                      staticStyle: {
                        "min-width": "32px",
                        height: "32px",
                        margin: "0",
                      },
                      attrs: { disabled: _vm.selectedIndex === 0 },
                      on: { click: _vm.previousPage },
                    },
                    [_c("md-icon", [_vm._v("keyboard_arrow_left")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedIndex,
                          expression: "selectedIndex",
                        },
                      ],
                      staticClass: "ellipsis",
                      attrs: { id: "time-select" },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedIndex = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    _vm._l(_vm.oldConversations, function (c, i) {
                      return _c("option", { key: i, domProps: { value: i } }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(c.email) +
                            "\n                            " +
                            _vm._s(_vm._f("date")(c.createdDate, "LLL")) +
                            "\n                        "
                        ),
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "md-button",
                    {
                      staticStyle: {
                        "min-width": "32px",
                        height: "32px",
                        margin: "0",
                      },
                      attrs: {
                        disabled:
                          _vm.selectedIndex ===
                            _vm.oldConversations.length - 1 && _vm.isEnd,
                      },
                      on: { click: _vm.nextPage },
                    },
                    [_c("md-icon", [_vm._v("keyboard_arrow_right")])],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.oldConversations.length
        ? _c(
            "div",
            { staticClass: "body" },
            [
              _vm.loadingMore
                ? _c("div", { staticClass: "spinnerClass" }, [_c("a-spin")], 1)
                : _vm._l(_vm.oldConversations, function (conversation, i) {
                    return _c(
                      "div",
                      { key: i },
                      [
                        i === _vm.selectedIndex
                          ? _vm._o(
                              _c("MessageList", {
                                attrs: {
                                  "always-scroll-to-bottom": true,
                                  colors: _vm.colors,
                                  messages: _vm.getMessages(conversation),
                                  participants:
                                    _vm.getParticipants(conversation),
                                },
                              }),
                              0,
                              i
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
              _vm._v(" "),
              _vm._l(_vm.oldConversations, function (conversation, index) {
                return false
                  ? _c(
                      "b-card",
                      {
                        key: index,
                        staticClass: "mb-1 rounded-0",
                        attrs: { "no-body": "" },
                      },
                      [
                        conversation._id !== _vm.activeConversation._id
                          ? [
                              _c(
                                "b-card-header",
                                {
                                  attrs: {
                                    "header-tag": "header",
                                    role: "tab",
                                  },
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { block: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleAccordion(index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(conversation.fullname) +
                                          "\n                            "
                                      ),
                                      _c("time", [
                                        _vm._v(
                                          "  " +
                                            _vm._s(
                                              _vm._f("date")(
                                                conversation.createdDate,
                                                "LLL"
                                              )
                                            )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-collapse",
                                {
                                  attrs: {
                                    id: "accordion-" + index,
                                    accordion: "my-accordion",
                                    role: "tabpanel",
                                  },
                                },
                                [
                                  _c(
                                    "b-card-body",
                                    [
                                      _vm._o(
                                        _c("MessageList", {
                                          attrs: {
                                            "always-scroll-to-bottom": true,
                                            colors: _vm.colors,
                                            messages: _vm.messages,
                                            participants: _vm.participants,
                                          },
                                        }),
                                        1,
                                        index
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.oldConversations.length < 1
                          ? [
                              _c(
                                "b-alert",
                                {
                                  staticClass: "rounded-0 mb-0 mt-2",
                                  attrs: { show: "" },
                                },
                                [_vm._v(_vm._s(_vm.$t("message.noMessage")))]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              false
                ? _c(
                    "div",
                    [
                      !_vm.isEnd && _vm.oldConversations.length !== 0
                        ? _c(
                            "a-button",
                            {
                              attrs: { loading: _vm.loadingMore },
                              on: { click: _vm.loadOldConversationsMore },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("message.loadMore")) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          )
        : _c(
            "div",
            { staticClass: "body" },
            [_c("a-result", { attrs: { title: "Konuşma Bulunamadı" } })],
            1
          ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }